import { NavLink } from 'react-router';
import { t } from '../../i18n';

const link = ({ isActive }: { isActive: boolean }) => `-mb-px border-b-2 px-3 py-2 text-sm ${isActive ? 'border-marca font-medium text-slate-900' : 'border-transparent text-slate-600 hover:text-slate-900'}`;

/** Secciones del módulo Proyectos. */
export function ProjectsNav() {
  return (
    <nav aria-label={t('pr.secciones')} className="flex gap-1 border-b border-slate-200">
      <NavLink to="/proyectos" end className={link}>
        {t('pr.titulo')}
      </NavLink>
      <NavLink to="/proyectos/cancha" className={link}>
        {t('ca.titulo_corto')}
      </NavLink>
      <NavLink to="/proyectos/solicitudes" className={link}>
        {t('sp.titulo')}
      </NavLink>
    </nav>
  );
}
